exports.default = {
  'new_conversation_tooltip': '建立對話',
  'history_tooltip': '歷史記錄',
  'conversation': '對話',
  'loading': '加載中',
  'expand': '展開',
  'collapse': '收起',
  'start_new_conversation': '建立對話',
  'history': '歷史紀錄',
  'pin_conversation': '置頂對話',
  'edit_conversation_title': '編輯對話名稱',
  'remove_conversation_confirm': '刪除確認',
  'please_enter_conversation_name': '請輸入新的對話名稱',
  'delete_conversation_confirm': '刪除後將無法復原，確定要刪除嗎？',
  'delete': '刪除',
  'cancel': '取消',
  'operation_failed': '操作失敗：{message}',
  'empty_conversation_id': '對話ID為空，請刷新頁面再試！',
  'empty_title': '請輸入會話標題！',
  'title_too_long': '標題不能超過150個字符',
  'copy_success': '複製成功',
  'copy_failed': '複製失敗，請稍後重試！',
  'no_agent_conversation': '您還未與任何智能體進行會話',
  'agent_deleted': '智能體已刪除，無法發起新對話',
  'no_more': '沒有更多了',
  'continue_chat': '和 Pai 接著聊',
  'ai_generated_content': '內容由 AI 大模型生成，請仔細甄別',
  'new_conversation': '建立對話',
  'add_conversation_title': '請輸入會話標題',
  'confirm': '確 定',
  'your_agents': '您的智能體',
  'edit_conversation_failed': '操作失敗：{message}',
  'add_top_success': '添加成功！',
  'export_pdf': '導出 PDF 文檔',
  'agent_center': '智能體中心',
  'remove_agent': '移除智能體',
  'add_agent': '添加智能體',
  'today': '今天',
  'search_agent_placeholder': '搜索智能體名稱或介紹',
  'recent': '最近',
  'points': '積分',
  'points_consumption': '每條信息消耗積分:',
  'remaining_points': '您目前剩餘積分:',
  'points_info_load_error': '積分信息加載失敗',
  'upgrade': '升級',
  'search_chat': '搜索智能體或對話...',
  'agent_type': '智能體',
  'conversation_message_type': '對話消息',
  'network_connection_unstable': '目前網路狀況不佳，請重新整理頁面後再試。'
}
